import { Injectable } from '@angular/core';
import { DelabNgxI18nServiceDefinition } from '@delab/ngx-ixconnect-components';
import { I18NDataDto } from 'src/.api-client/models/i-18-n-data-dto';
import { CachesService } from './cache/caches.service';

@Injectable({ providedIn: 'root' })
export class I18nService implements DelabNgxI18nServiceDefinition {
    private readonly FALLBACK_LANGUAGES: string[] = ['en', 'de'];
    private readonly DEFAULT_LANGUAGE: string = 'de';

    private _i18nData?: I18NDataDto['data'];

    constructor(private _cachesService: CachesService) {
        this._cachesService.i18nData.valueObs.subscribe((i18nData) => {
            this._i18nData = i18nData || undefined;
        });
    }

    loadTranslations(maxAge?: number, forceUpdate?: boolean) {
        return this._cachesService.i18nData.update(maxAge, forceUpdate);
    }

    translate(key: string, language: string = this.DEFAULT_LANGUAGE): string {
        if (!key) {
            return '';
        }

        const i18nValue = (this._i18nData || {})[key];

        if (!i18nValue) {
            return key;
        }
        for (const lang of [language, ...this.FALLBACK_LANGUAGES]) {
            const translation: string | undefined = i18nValue.translations[lang];
            if (typeof translation === 'string') {
                return translation;
            }
        }

        return key;
    }
}
